
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { AuthHttp } from '../../admin/services/token.service';
// import { AppConstant } from './../../shared/constant/app.constant';
import { Injectable } from '@angular/core';


import { AppConfigService } from '../../shared/services/app.config.service';

let AppConstant: any = {};
@Injectable()
export class JobTitleService {
    constructor(private http: AuthHttp, private appConfigServ: AppConfigService) {
        AppConstant = appConfigServ;
    }

    get() {
        return this.http.get(`setup/jobtitle/company`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    addUpdateJObTitle(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`setup/job-title`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
}